module.exports = __webpack_public_path__ + "img/ban_img.4550a2e3.png";